export const activeTariffsKeys = {
    all: ['activeTariff'] as const,
    byUin: (uin: string | undefined) => [...activeTariffsKeys.all, 'uin', uin] as const
}

export const userKeys = {
    all: ['user'] as const,
    companies: () => [...userKeys.all, 'companies'] as const,
    profile: () => [...userKeys.all, 'profile'] as const,
}
